import _objectWithoutProperties from "/Users/oct16/work/Cat/timecat-issue-helper/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import { MDXTag } from '@mdx-js/tag';
export default (function (_ref) {
  var components = _ref.components,
      props = _objectWithoutProperties(_ref, ["components"]);

  return /*#__PURE__*/React.createElement(MDXTag, {
    name: "wrapper",
    components: components
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "p",
    components: components
  }, "Clear and concise reproduction instructions are important for us to be able to triage your issue in a timely manner. Note that you can use ", /*#__PURE__*/React.createElement("a", {
    href: "https://guides.github.com/features/mastering-markdown/",
    target: "_blank"
  }, "Markdown"), " to format lists and code."));
});